export const rotationModes = {
  DEFAULT: 0,
  THREESIXTY: 1,
};
